/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import { UIStrings } from '@sonatype/nexus-ui-plugin';
import PrivilegesStrings from './pages/admin/security/PrivilegesStrings';
import RolesStrings from './pages/admin/security/RolesStrings';
import UsersStrings from './pages/admin/security/UsersStrings';
import ContentSelectorsStrings from './pages/admin/repository/ContentSelectorsStrings';
import RepositoriesStrings from './pages/admin/repository/RepositoriesStrings';
import RoutingRulesStrings from './pages/admin/repository/RoutingRulesStrings';
import AccountStrings from './pages/user/AccountStrings';
import NuGetApiKeyStrings from './pages/user/NuGetApiKeyStrings';
import IqServerStrings from './pages/admin/IqServerStrings';
import ApiStrings from './pages/admin/system/ApiStrings';
import ProprietaryRepositoriesStrings from './pages/admin/repository/ProprietaryRepositoriesStrings';
import TasksStrings from './pages/admin/system/TasksStrings';
import ReplicationStrings from './pages/admin/repository/ReplicationStrings';
import UserTokenConfigurationStrings from './pages/admin/security/UserTokenStrings';
import ServiceAccountTokensStrings from './pages/admin/security/ServiceAccountTokensStrings';
import UserTokenStrings from './pages/user/UserTokenStrings';
import WelcomeStrings from './pages/user/WelcomeStrings';
import TagsStrings from './pages/browse/tags/TagsStrings';
import UploadStrings from './pages/browse/upload/UploadStrings';
import BrowseStrings from './pages/browse/browse/BrowseStrings';
import UpgradeAlertStrings from './UpgradeAlertStrings';
import UpgradeTriggerModalStrings from './UpgradeTriggerModalStrings';
import ZDUMarketingModalStrings from './ZDUMarketingModalStrings';
import MaliciousRiskStrings from './pages/maliciousrisk/MaliciousRiskStrings';
import SearchStrings from './pages/browse/search/SearchStrings';
import RepositoryDirectoryStrings from './pages/admin/repository/RepositoryDirectoryStrings';
import AdminSecurityDirectoryStrings from './pages/admin/repository/AdminSecurityDirectoryStrings';
import AdminSystemDirectoryStrings from './pages/admin/system/AdminSystemDirectoryStrings';
import AdminDirectoryStrings from './pages/admin/system/AdminDirectoryStrings';

export default {
  ...UIStrings,

  // welcome page
  ...WelcomeStrings,

  // browse
  ...TagsStrings,
  ...BrowseStrings,
  ...UploadStrings,
  ...SearchStrings,

  // admin
  ...IqServerStrings,

  // admin/repository
  ...ContentSelectorsStrings,
  ...ProprietaryRepositoriesStrings,
  ...RepositoriesStrings,
  ...ReplicationStrings,
  ...RoutingRulesStrings,

  // admin/security
  ...PrivilegesStrings,
  ...RolesStrings,
  ...UsersStrings,
  ...UserTokenConfigurationStrings,
  ...ServiceAccountTokensStrings,

  // admin/support

  // admin/system
  ...ApiStrings,
  ...TasksStrings,

  // admin/riskvisualizer
  ...MaliciousRiskStrings,

  // user
  ...AccountStrings,
  ...NuGetApiKeyStrings,
  ...UserTokenStrings,
  ...UpgradeAlertStrings,
  ...UpgradeTriggerModalStrings,
  ...ZDUMarketingModalStrings,

  // system/upgrade
  ...RepositoryDirectoryStrings,
  ...AdminSecurityDirectoryStrings,
  ...AdminSystemDirectoryStrings,
  ...AdminDirectoryStrings,
  // other
  FORMAT_PLACEHOLDER: 'Format',

  OPEN_DASHBOARD_LINK: 'IQ Server Dashboard',

  HEALTHCHECK_EULA: {
    HEADER: 'Nexus IQ Server Terms of Use',
    BUTTONS: {
      ACCEPT: 'I accept',
      DECLINE: 'I do not accept'
    }
  },

  ANALYZE_APPLICATION: {
    HEADER: 'Analyze Application',
    MAIN: 'Application analysis performs a deep inspection of this application, identifying potential risks.<br/> More information is available here <a href="http://links.sonatype.com/products/insight/ac/home">here</a>',
    EMAIL: {
      LABEL: 'Email address',
      DESCRIPTION: 'The address where the summary report will be sent'
    },
    PASSWORD: {
      LABEL: 'Report password',
      DESCRIPTION: 'A password to gain access to the detailed report'
    },
    PACKAGES: {
      LABEL: 'Proprietary packages',
      DESCRIPTION: 'A comma separated list of proprietary packages'
    },
    REPORT: {
      LABEL: 'Report label',
      DESCRIPTION: 'The name the report will be given'
    },
    SELECT_ASSET: {
      LABEL: 'Select Asset',
      DESCRIPTION: 'Select an asset to base the analysis on'
    },
    BUTTONS: {
      ANALYZE: 'Analyze',
      CANCEL: 'Cancel'
    }
  }
};
